<div class="shadow-md bg-white w-full flex flex-col max-h-full">
  <div class="flex flex-row justify-between items-center p-8 bg-primary-600 text-contrast overflow-hidden rounded-t-md">
    <h2 class="m-0 font-bold ">{{ { key: 'cancelBooking' } | i18n }}</h2>
    @if ((displayType | async) !== 'loading') {
      <button (click)="close()">
        <ng-icon name="heroXMark" class="h-5 w-5 flex-shrink-0" size="24px"></ng-icon>
      </button>
    }
  </div>

  <div class="flex flex-col p-8">
    <div class="flex-flex-col">
      <div class="block text-sm leading-6 text-gray-900 font-bold">{{ { key: 'date' } | i18n }}</div>
      <div class="text-sm mt-2">
        {{ data.event.time }}
      </div>
    </div>

    <div class="flex-flex-col mt-4">
      <div class="block text-sm leading-6 text-gray-900 font-bold">{{ { key: 'place' } | i18n }}</div>
      <div class="text-sm mt-2">
        {{ data.event.place | i18n }}
      </div>
    </div>

    @switch (displayType | async) {
      @case ('success') {
        <div class="flex flex-row items-center my-12">
          <ng-icon name="heroCheckCircle" size="32px" class="mr-4 text-green-700"></ng-icon>
          <div class="flex flex-col">
            <h3 class="mb-2">{{ { key: 'cancellationSuccess' } | i18n }}</h3>
            <!-- <p class="text-sm">{{ { key: 'cancellationConfirmation' } | i18n }}</p> -->
          </div>
        </div>
        <button
          class="w-full items-center justify-center border border-transparent py-2 px-4 text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 bg-primary-600 hover:bg-primary-700 focus:ring-primary-500"
          (click)="close(true)"
        >
          {{ { key: 'close' } | i18n }}
        </button>
      }
      @case ('error') {
        <div class="flex flex-row items-center my-12">
          <ng-icon name="heroXCircle" size="32px" class="mr-4 text-red-600"></ng-icon>
          <h3 class="mb-0">{{ { key: 'cancellationError' } | i18n }}</h3>
        </div>
        <button
          class="w-full items-center justify-center border border-transparent py-2 px-4 text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 bg-primary-600 hover:bg-primary-700 focus:ring-primary-500"
          (click)="close()"
        >
          {{ { key: 'close' } | i18n }}
        </button>
      }
      @case ('loading') {
        <div class="flex flex-row items-center my-12">
          <app-loading [classes]="['h-6', 'w-6', 'mr-4']" [noWhitespace]="true" [hideText]="true"></app-loading>
          <h3 class="mb-0">{{ { key: 'pleaseWait' } | i18n }}</h3>
        </div>
      }
      @default {
        <button
          class="mt-8 w-full items-center justify-center border border-transparent py-2 px-4 text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 bg-primary-600 hover:bg-primary-700"
          (click)="cancelBooking()"
        >
          {{ { key: 'cancel' } | i18n }}
        </button>
        <button
          class="mt-4 w-full items-center justify-center text-primary-600 hover:text-primary-700 border border-transparent py-2 px-4 text-sm font-medium focus:outline-none"
          (click)="close()"
        >
          {{ { key: 'abort' } | i18n }}
        </button>
      }
    }
  </div>
</div>
